export default "/images/smart_contracts_development/smart_contract_development_and_audits__heading_icon.png";